import { useActiveStepId } from 'features/libra/ticket/TicketStateContext'
import { useCallback } from 'react'

import type { ZoneAnalysisAnchor } from './zoneCommentAnchors'

type ZonePropertyAnchor = Extract<ZoneAnalysisAnchor, { type: 'zone-property' }>

export type ZonePropertyKey =
  // ZoneDescriptionPanel
  | 'title'
  | 'description'
  | 'review_notes'
  | 'assumptions'
  | 'zone_recommendations'
  // DesignFunctionPanel
  | 'material'
  | 'geometry'
  | 'height_mm'
  | 'external_diameter_mm'
  | 'total_surface_area_sq_m'
  | 'wall_thickness_shell_mm'
  | 'wall_thickness_heads_mm'
  | 'corrosion_allowance_mm'
  // NiiStrategyPanel
  | 'nii_strategy.degradation_likely'
  | 'nii_strategy.degradation_predictable'
  | 'nii_strategy.degradation_severity'
  | 'nii_strategy.strategy_type_override'
  // RbaInformationPanel
  | 'rba_info.density_of_degradation'
  | 'rba_info.measurement_accuracy'
  | 'rba_info.tolerance_of_degradation'
  | 'rba_info.spatial_homogeneity'

export function useZonePropertyAnchor(
  zoneId: string
): (property: ZonePropertyKey) => ZonePropertyAnchor {
  const stepId = useActiveStepId()
  return useCallback(
    (property: ZonePropertyKey): ZonePropertyAnchor => ({
      type: 'zone-property',
      stepId,
      zoneId,
      property,
    }),
    [stepId, zoneId]
  )
}
